import React, { useState, useEffect } from 'react';
import './style.css';

import logo1 from "../../assets/img/p-management/property1.png"
import logo2 from "../../assets/img/p-management/property2.png"
import logo3 from "../../assets/img/p-management/property3.png"
import logo4 from "../../assets/img/p-management/property4.png"
import logo5 from "../../assets/img/p-management/property5.png"
import logo6 from "../../assets/img/p-management/property6.png"
import logo7 from "../../assets/img/p-management/property7.png"
import logo8 from "../../assets/img/p-management/property8.png"
import logo9 from "../../assets/img/p-management/property9.png"
import logo10 from "../../assets/img/p-management/property10.png"
import logo11 from "../../assets/img/p-management/property11.png"
import logo12 from "../../assets/img/p-management/property12.png"
import logo13 from "../../assets/img/p-management/property13.png"
import logo14 from "../../assets/img/p-management/property14.png"
import logo15 from "../../assets/img/p-management/property15.png"
import logo16 from "../../assets/img/p-management/property16.png"
import logo17 from "../../assets/img/p-management/property17.png"
import logo18 from "../../assets/img/p-management/property18.png"
import logo19 from "../../assets/img/p-management/property19.png"
import logo20 from "../../assets/img/p-management/property20.png"
import logo21 from "../../assets/img/p-management/property21.png"
import logo22 from "../../assets/img/p-management/property22.png"
import logo23 from "../../assets/img/p-management/property23.png"
import logo24 from "../../assets/img/p-management/property24.png"
import logo25 from "../../assets/img/p-management/property25.png"
import logo26 from "../../assets/img/p-management/property26.png"
import logo27 from "../../assets/img/p-management/property27.png"
import logo28 from "../../assets/img/p-management/property28.png"
import logo29 from "../../assets/img/p-management/property29.png"
import logo30 from "../../assets/img/p-management/property30.png"
import logo31 from "../../assets/img/p-management/property31.png"
import logo32 from "../../assets/img/p-management/property32.png"
import logo33 from "../../assets/img/p-management/property33.png"
import logo34 from "../../assets/img/p-management/property34.png"
import logo35 from "../../assets/img/p-management/property35.png"
import logo36 from "../../assets/img/p-management/property36.png"
import logo37 from "../../assets/img/p-management/property37.png"
import logo38 from "../../assets/img/p-management/property38.png"
import logo39 from "../../assets/img/p-management/property39.png"
import logo40 from "../../assets/img/p-management/property40.png"
import logo41 from "../../assets/img/p-management/property41.png"
import logo42 from "../../assets/img/p-management/property42.png"
import logo43 from "../../assets/img/p-management/property43.png"
import logo44 from "../../assets/img/p-management/property44.png"
import logo45 from "../../assets/img/p-management/property45.png"
import logo46 from "../../assets/img/p-management/property46.png"
import logo47 from "../../assets/img/p-management/property47.webp"
import logo48 from "../../assets/img/p-management/property48.png"
import logo49 from "../../assets/img/p-management/property49.png"
import logo50 from "../../assets/img/p-management/property50.png"
import logo51 from "../../assets/img/p-management/property51.png"
import logo52 from "../../assets/img/p-management/property52.png"
import logo53 from "../../assets/img/p-management/property53.png"
import logo54 from "../../assets/img/p-management/property54.png"
import logo55 from "../../assets/img/p-management/property55.png"
import logo56 from "../../assets/img/p-management/property56.png"
import logo57 from "../../assets/img/p-management/property57.png"
import logo58 from "../../assets/img/p-management/property58.png"
import logo59 from "../../assets/img/p-management/property59.png"
import logo60 from "../../assets/img/p-management/property60.png"
import logo61 from "../../assets/img/p-management/property61.png"
import logo62 from "../../assets/img/p-management/property62.png"
import logo63 from "../../assets/img/p-management/property63.png"
import logo64 from "../../assets/img/p-management/property64.png"
import logo65 from "../../assets/img/p-management/property65.png"
import logo66 from "../../assets/img/p-management/property66.png"
import logo67 from "../../assets/img/p-management/property67.png"
import logo68 from "../../assets/img/p-management/property68.png"
import logo69 from "../../assets/img/p-management/property69.png"
import logo70 from "../../assets/img/p-management/property70.png"
import logo71 from "../../assets/img/p-management/property71.png"
import logo72 from "../../assets/img/p-management/property72.png"
import logo73 from "../../assets/img/p-management/property73.png"
import logo74 from "../../assets/img/p-management/property74.png"
import logo75 from "../../assets/img/p-management/property75.png"
import logo76 from "../../assets/img/p-management/property76.png"
import logo77 from "../../assets/img/p-management/property77.png"
import logo78 from "../../assets/img/p-management/property78.png"
import logo79 from "../../assets/img/p-management/property79.png"
import logo80 from "../../assets/img/p-management/property80.png"
import logo81 from "../../assets/img/p-management/property81.png"
import logo82 from "../../assets/img/p-management/property82.png"
import logo83 from "../../assets/img/p-management/property83.png"
import logo84 from "../../assets/img/p-management/property84.png"
import logo85 from "../../assets/img/p-management/property85.png"
import logo86 from "../../assets/img/p-management/property86.png"
import logo87 from "../../assets/img/p-management/property87.png"
import logo88 from "../../assets/img/p-management/property88.png"
import logo89 from "../../assets/img/p-management/property89.png"
import logo90 from "../../assets/img/p-management/property90.png"
import logo91 from "../../assets/img/p-management/property91.png"
import logo92 from "../../assets/img/p-management/property92.png"
import logo93 from "../../assets/img/p-management/property93.png"
import logo94 from "../../assets/img/p-management/property94.png"
import logo95 from "../../assets/img/p-management/property95.png"


export default function PropertyManagers () {
 
  const originalProperties = [
    { "logo": logo1 },
    { "logo": logo2 },
    { "logo": logo3 },
    { "logo": logo4 },
    { "logo": logo5 },
    { "logo": logo6 },
    { "logo": logo7 },
    { "logo": logo8 },
    { "logo": logo9 },
    { "logo": logo10 },
    { "logo": logo11 },
    { "logo": logo12 },
    { "logo": logo13 },
    { "logo": logo14 },
    { "logo": logo15 },
    { "logo": logo16 },
    { "logo": logo17 },
    { "logo": logo18 },
    { "logo": logo19 },
    { "logo": logo20 },
    { "logo": logo21 },
    { "logo": logo22 },
    { "logo": logo23 },
    { "logo": logo24 },
    { "logo": logo25 },
    { "logo": logo26 },
    { "logo": logo27 },
    { "logo": logo28 },
    { "logo": logo29 },
    { "logo": logo30 },
    { "logo": logo31 },
    { "logo": logo32 },
    { "logo": logo33 },
    { "logo": logo34 },
    { "logo": logo35 },
    { "logo": logo36 },
    { "logo": logo37 },
    { "logo": logo38 },
    { "logo": logo39 },
    { "logo": logo40 },
    { "logo": logo41 },
    { "logo": logo42 },
    { "logo": logo43 },
    { "logo": logo44 },
    { "logo": logo45 },
    { "logo": logo46 },
    { "logo": logo47 },
    { "logo": logo48 },
    { "logo": logo49 },
    { "logo": logo50 },
    { "logo": logo51 },
    { "logo": logo52 },
    { "logo": logo53 },
    { "logo": logo54 },
    { "logo": logo55 },
    { "logo": logo56 },
    { "logo": logo57 },
    { "logo": logo58 },
    { "logo": logo59 },
    { "logo": logo60 },
    { "logo": logo61 },
    { "logo": logo62 },
    { "logo": logo63 },
    { "logo": logo64 },
    { "logo": logo65 },
    { "logo": logo66 },
    { "logo": logo67 },
    { "logo": logo68 },
    { "logo": logo69 },
    { "logo": logo70 },
    { "logo": logo71 },
    { "logo": logo72 },
    { "logo": logo73 },
    { "logo": logo74 },
    { "logo": logo75 },
    { "logo": logo76 },
    { "logo": logo77 },
    { "logo": logo78 },
    { "logo": logo79 },
    { "logo": logo80 },
    { "logo": logo81 },
    { "logo": logo82 },
    { "logo": logo83 },
    { "logo": logo84 },
    { "logo": logo85 },
    { "logo": logo86 },
    { "logo": logo87 },
    { "logo": logo88 },
    { "logo": logo89 },
    { "logo": logo90 },
    { "logo": logo91 },
    { "logo": logo92 },
    { "logo": logo93 },
    { "logo": logo94 },
    { "logo": logo95 },
  ];

  const properties = [...originalProperties];
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 25;
  const totalPages = Math.ceil(properties.length / itemsPerPage);

  // Auto-advance slides (no transition)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalPages);
    }, 4000);

    return () => clearInterval(interval);
  }, [totalPages]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalPages) % totalPages);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalPages);
  };

  return (
    <div className="carousel-container-property">
      <h2 className="section-header" data-aos="zoom-in" data-aos-duration="1500">
        Property Managers
      </h2>
      
      <div
        className="carousel-wrapper-property"
        data-aos="zoom-in"
        data-aos-duration="2000"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: 'none', // Disable all transitions
        }}
      >
        {Array.from({ length: totalPages }).map((_, chunkIndex) => (
          <div className="carousel-slide-property" key={chunkIndex}>
            {properties
              .slice(
                chunkIndex * itemsPerPage,
                (chunkIndex + 1) * itemsPerPage
              )
              .map((partner, index) => (
                <div className="carousel-item-property" key={index}>
                  <img src={partner.logo} alt="Property logo" />
                </div>
              ))}
          </div>
        ))}
      </div>

      <button onClick={handlePrev} className="carousel-button-property prev">‹</button>
      <button onClick={handleNext} className="carousel-button-property next">›</button>
    </div>
  );
}